export default "__VITE_ASSET__DOB94shA__"